import React from "react";
import Fade from "react-reveal/Fade";
import "./Footer.scss";

const Footer = () => {
  return (
    <Fade bottom>
      <div className="footer">
        <div className="row">
          <div className="col-lg-12">
            <div className="footer-content text-center">
              <div className="logo">
                <h1 className="mylogo">Nandun Diaz</h1>
                <p className="description mt-3">
                  All rights reserved! © {new Date().getFullYear()} | v.2.0.1 |
                  Made with <i className="bi bi-heart-fill"></i> by Nandun
                </p>
                <a
                  href="https://www.buymeacoffee.com/nandundiaz"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    loading="lazy"
                    src="https://cdn.buymeacoffee.com/buttons/v2/default-blue.png"
                    alt="Buy Me A Coffee"
                    className="bmc"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default Footer;
